<template>
  <div>
    <transition name="slide-fade">
      <div class="loading-integreat" v-if="isLoadingPage">
        <div class="initial-load-animation">
          <div class="linkedin-image"></div>
          <div class="loading-bar">
            <div class="blue-bar"></div>
          </div>
        </div>
      </div>
    </transition>
    <div v-if="page === 'form'">
      <div class="level disablePrint pd-0-75rem">
        <p class="is-size-5 has-text-weight-semibold">
          {{ $t("form.formHeader") }}
        </p>
        <b-dropdown ref="dropdowntablet" position="is-bottom-left">
          <button class="button btn-Filter" slot="trigger">
            <span class="icon is-small">
              <i class="fa fa-filter"></i>
            </span>
            <span>{{ $t("form.formFilter") }}</span>
          </button>
          <b-dropdown-item custom paddingless>
            <div class="modal-card mx-not modal-search">
              <section class="modal-card-body contentSearch">
                <div class="headerFilter">
                  <span class="icon is-small is-size-5">
                    <i class="fa fa-filter"></i>
                  </span>
                  <span
                    class="is-padding-sm-x is-size-5 has-text-weight-normal"
                    >{{ $t("form.formFilter") }}</span
                  >
                </div>

                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    icon="search"
                    :placeholder="$t('selectBatch.filterPlaceholderFirst')"
                    v-model="searchName"
                    expanded
                  ></b-input>
                </b-field>

                <b-field grouped class="year-hid-maxLength">
                  <b-autocomplete
                    class="is-medium"
                    v-model="searchBudget"
                    icon-pack="fas"
                    icon="location-arrow"
                    :data="filteredDataBudget"
                    maxlength="4"
                    :placeholder="$t('selectBatch.filterPlaceholderSecond')"
                    @select="(option) => (selectedBudget = option)"
                    expanded
                  >
                  </b-autocomplete>
                </b-field>

                <b-field grouped>
                  <div class="control is-expanded level">
                    <div class="search-btn">
                      <button class="button btnSearch" @click="filter()">
                        {{ $t("message.btnSearch") }}
                      </button>
                    </div>
                    <div class="reset-btn">
                      <button @click="resetFilter()" class="button btnReset th">
                        {{ $t("message.btnReset") }}
                      </button>
                    </div>
                  </div>
                </b-field>
              </section>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div
        v-if="batchFormsFilter.length === 0"
        class="columns is-vcentered m-h-auto"
        id="noData"
      >
        <div
          class="column has-text-centered is-flex is-align-center is-justify-center"
        >
          <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">
            ***
          </p>
          <p class="has-text-grey is-size-6 th is-padding-x has-text-centered">
            {{ $t("form.notFoundBatch") }}
          </p>
          <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">
            ***
          </p>
        </div>
      </div>

      <div v-else class="columns m-h-auto is-flex-wrap is-align-center">
        <div
          v-for="(item, index) in batchFormsFilter"
          :key="index"
          class="column is-4"
        >
          <div class="has-background-white box-border pd-20">
            <a
              @click="changPage(item, 'formList')"
              v-if="item.form.length !== 0"
              class="is-size-7 is-flex is-align-center is-justify-end th edit-form"
            >
              <!-- <b-icon pack="fas" icon="pencil-alt" size="is-small" class="mg-r-5"></b-icon> -->
              {{ $t("form.formInCardDetail") }}
            </a>
            <div v-else class="pd-10"></div>
            <div
              class="is-align-center is-justify-center is-flex is-flex-column mg-10"
            >
              <div class="box-circle-logo">
                <b-icon
                  pack="fas"
                  icon="file-alt"
                  size="is-large"
                  custom-size="fa-5x"
                  type="is-white"
                >
                </b-icon>
              </div>
            </div>

            <p class="pd-5 has-text-centered th">
              <span class="has-text-weight-normal"
                >{{ $t("form.formBatchName") }} :</span
              >
              <span class="pd-l-5" :title="item.name">{{
                item.name | snippetMiniSmall
              }}</span>
            </p>
            <p class="pd-5 has-text-centered th">
              <span class="has-text-weight-normal"
                >{{ $t("form.formFiscalYear") }}:</span
              >
              <span class="pd-l-5">{{
                item.fiscalYear | snippetMiniSmall
              }}</span>
            </p>
            <div class="has-text-centered mg-10">
              <a
                v-if="item.form.length === 0"
                @click="openModalForm(item, 'add')"
                class="button btn-form th"
                >{{ $t("form.modalChoseFormHeader") }}</a
              >
              <a
                v-else
                @click="openModalForm(item, 'edit')"
                @mouseover="hoverForm = item.batchId"
                @mouseout="hoverForm = null"
                class="button btn-form-outlined th"
                :title="getFormName(item.form[0].id)"
                >{{
                  hoverForm === item.batchId
                    ? $t("form.changeFormType")
                    : getFormName(item.form[0].id) | snippetMobile
                }}</a
              >
            </div>
          </div>
        </div>
      </div>

      <b-modal
        :active.sync="isForm"
        :width="2000"
        @close="closeModalIsForm"
        class="modal-max"
      >
        <div class="card">
          <div class="card-content">
            <div class="content">
              <div class="columns m-h-auto is-vcentered border-bottom is-">
                <div class="column is-3 th has-text-weight-normal is-size-5">
                  <p v-if="isFormModalType === 'add'">
                    {{ $t("form.modalChoseFormHeader") }}
                  </p>
                  <p v-if="isFormModalType === 'edit'">
                    {{ $t("form.modalChangeFormHeader") }}
                  </p>
                </div>
                <div class="column is-4">
                  <p v-if="formsUserData !== null">
                    <span class="has-text-weight-normal th"
                      >{{ $t("form.formBatchName") }}:</span
                    ><span class="th pd-l-5" :title="formsUserData.name">{{
                      formsUserData.name | snippetProfileEdit
                    }}</span>
                  </p>
                </div>
                <div class="column">
                  <p v-if="formsUserData !== null">
                    <span class="has-text-weight-normal th"
                      >{{ $t("form.formFiscalYear") }}:</span
                    >
                    <span class="th pd-l-5">{{
                      formsUserData.fiscalYear | snippetProfileEdit
                    }}</span>
                  </p>
                </div>
              </div>
              <div class="columns m-h-auto">
                <div class="column is-4 is-paddingless">
                  <div class="box-border mg-10 h-100-per">
                    <div class="has-text-centered border-bottom pd-y-15">
                      <p
                        v-if="formsComponent.length !== 0"
                        class="is-size-6 th has-text-weight-normal"
                      >
                        {{ $t("form.formTypeAll") }} ({{
                          formsComponent.form.length
                        }}
                        {{ $t("form.typeUnit") }})
                      </p>
                    </div>
                    <div class="column pd-x-20">
                      <b-input
                        placeholder="Search..."
                        type="search"
                        icon-pack="fas"
                        v-model="searchFormName"
                        icon="search"
                      >
                      </b-input>
                    </div>
                    <div class="scroll pd-x-10">
                      <div
                        class="column"
                        v-for="item in filterFormName"
                        :key="item._id"
                      >
                        <div class="is-flex is-align-center">
                          <div class="field is-marginless">
                            <b-radio
                              type="is-info"
                              v-model="radioForm"
                              :disabled="
                                formsUserData !== null &&
                                formsUserData.form.length !== 0 &&
                                formsUserData.form[0].id === item._id
                              "
                              @input="setRadioForm"
                              :native-value="{ id: item._id, type: item.type }"
                              name="dataOfradio"
                            >
                            </b-radio>
                          </div>
                          <p class="is-size-6 th" :title="item.name">
                            {{ item.name }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-8 is-paddingless">
                  <div class="box-border mg-10 h-100-per">
                    <div v-if="radioForm !== null">
                      <div class="has-text-centered border-bottom pd-y-15">
                        <p class="is-size-6 has-text-weight-normal th">
                          {{ getFormName(radioForm.id) }}
                        </p>
                      </div>
                      <div>
                        <FormMange
                          v-if="renderComponent === true"
                          :tab="false"
                          :formProps="getFormToId(this.radioForm)"
                          :startupIdProps="null"
                          :batchData="batchData"
                          :demo="true"
                          :isLockForm="null"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns m-h-auto">
                <div
                  class="column is-offset-4 has-text-centered is-paddingless"
                >
                  <a
                    @click="changFormToBatch()"
                    v-if="isFormModalType === 'add'"
                    class="button btn-form-add th"
                    >{{ $t("message.btnOK") }}</a
                  >
                  <a
                    @click="changFormToBatch()"
                    v-if="
                      isFormModalType === 'edit' &&
                      formsUserData.form[0] !== radioForm
                    "
                    class="button btn-form-add th"
                    >{{ $t("message.change") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div v-if="this.batchData !== null && page === 'formList'">
      <FormMange
        v-if="renderComponent === true"
        :tab="true"
        :formProps="getFormToId(this.batchData.form[0])"
        :startupId="null"
        :batchData="batchData"
        @changPage="changPage"
        :demo="false"
        :isLockForm="null"
      />
    </div>
  </div>
</template>
<script>
import { HTTP, HTTPDynamic } from "../axios";
import FormMange from "./form/FormMange";

export default {
  components: {
    FormMange,
  },
  data() {
    return {
      page: "form",
      isForm: false,
      radioForm: null,
      formsUserData: null,
      formsComponent: [],
      batchForms: [],
      batchFormsFilter: [],
      searchFormName: "",
      isFormModalType: null,
      searchName: "",
      searchBudget: "",
      isLoadingPage: null,
      budget: ["2559", "2560", "2561", "2562", "2563", "2564", "2565"],
      hoverForm: null,
      batchData: null,
      renderComponent: false,
      staffLists: [],
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    token() {
      return this.$store.state.token;
    },
    filterFormName() {
      if (this.searchFormName !== "") {
        return this.formsComponent.form.filter(
          (item) =>
            item.name
              .toLowerCase()
              .indexOf(this.searchFormName.toLowerCase()) >= 0
        );
      } else {
        return this.formsComponent.form;
      }
    },
    filteredDataBudget() {
      return this.budget.filter(
        (option) =>
          option
            .toString()
            .toLowerCase()
            .indexOf(this.searchBudget.toLowerCase()) >= 0
      );
    },
  },
  created() {
    this.fethBatchForm();
    this.fethFormAllAdmin();
  },
  mounted() {
    this.isLoadingPage = true;
  },
  methods: {
    emitRealTimeNotiStaffAll() {
      this.staffLists.map((item) => {
        this.$socket.emit("listNoti", {
          userId: item.staffId,
          batchId: "",
        });
      });
    },
    async fetchStaff(id) {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.get(`api/user/get/staff/on/batch/${id}`)
        .then((res) => {
          //console.log('api/user/get/staff/on/batch', res);
          if (res.data.success) {
            this.staffLists = res.data.obj.staffs;
          } else {
            this.staffLists = [];
          }
        })
        .catch((e) => {
          console.log("api/user/get/staff/on/batch/error", e);
        });
    },
    getFormToId(input) {
      if (input !== null && typeof input !== "undefined") {
        let forms = this.formsComponent.form.filter(
          (item) => item._id === input.id
        );
        if (forms.length > 0) {
          return forms[0];
        } else {
          return [];
        }
      } else {
        return {};
      }
    },
    fethFormAllAdmin() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/all/form/on/admin`)
        .then((res) => {
          //console.log("get/all/form/on/admin", res);
          if (res.data.success) {
            this.formsComponent = {
              form: [],
            };
            if (res.data.obj.components.length === 0) {
              this.isLoadingPage = false;
            }

            for (
              let index = 0;
              index < res.data.obj.components.length;
              index++
            ) {
              setTimeout(() => {
                if (res.data.obj.components[index].type !== "component") {
                  this.fetchTmp(res.data.obj.components[index].id);
                } else {
                  this.fethFormComponent(res.data.obj.components[index].id);
                }
              }, 100 * index);
            }
          } else {
            this.formsComponent = [];
          }
        })
        .catch((e) => {
          console.log("get/all/form/on/admin/error", e);
        });
    },
    async fetchTmp(id) {
      let data = {
        templateId: id,
      };
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`get/template/by/id`, data)
        .then((res) => {
          //console.log("get/template/by/id", res);
          if (res.data.success) {
            this.formsComponent.form.push(res.data.obj);
          }
          this.isLoadingPage = false;
          this.renderComponent = true;
        })
        .catch((e) => {
          this.isLoadingPage = false;
          this.renderComponent = true;
          console.log("get/template/by/id/error", e);
        });
    },
    async getComponent(id, form) {
      let arr = [];
      arr[0] = id;

      let data = {
        components: arr,
      };

      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`get/component/by/id`, data)
        .then((res) => {
          // console.log("get/component/by/id", res.data.obj.form[0]);
          if (res.data.success) {
            if (typeof res.data.obj.form[0] !== "undefined") {
              res.data.obj.form[0].components.map((item, index) => {
                form.push(item);
              });
            }
          } else {
            this.dataFormInput = [];
          }
        })
        .catch((e) => {
          console.log("get/component/by/id/error", e);
        });
    },
    async fethFormComponent(value) {
      let data = {
        components: [value],
      };
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`get/component/by/id`, data)
        .then((res) => {
          //console.log("get/component/by/id",res)
          if (res.data.success) {
            let obj = {
              components: res.data.obj.form[0].components,
              name: res.data.obj.form[0].name,
              _id: res.data.obj.form[0]._id,
              type: "component",
            };
            this.formsComponent.form.push(obj);
          }
          this.isLoadingPage = false;
          this.renderComponent = true;
        })
        .catch((e) => {
          this.isLoadingPage = false;
          this.renderComponent = true;
          console.log("get/component/by/id/error", e);
        });
    },
    fethBatchForm() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/all/batch/and/form`)
        .then((res) => {
          //console.log("get/all/batch/and/form", res);
          if (res.data.success) {
            let data = res.data.obj.batchs.sort((a, b) => {
              const modifier = -1;
              if (a.createdAt < b.createdAt) return -1 * modifier;
              if (a.createdAt > b.createdAt) return 1 * modifier;
              return 0;
            });
            this.batchForms = data;
            this.batchFormsFilter = data;
          } else {
            this.batchForms = [];
          }
        })
        .catch((e) => {
          console.log("get/all/batch/and/form/error", e);
        });
    },
    changFormToBatch() {
      this.isLoadingPage = true;
      let data = {
        oldForm:
          this.formsUserData.form.length !== 0
            ? this.formsUserData.form[0]
            : "",
        newForm: { id: this.radioForm.id, type: this.radioForm.type },
        batchId: this.formsUserData.batchId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`push/form/to/batch`, data)
        .then((res) => {
          // console.log("push/form/to/batch", res);
          if (res.data.success) {
            this.fethBatchForm();
            this.isForm = false;
            this.$store.commit("setModalActive", false);
            this.emitRealTimeNotiStaffAll();
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
          this.isLoadingPage = false;
        })
        .catch((e) => {
          console.log("push/form/to/batch/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
          this.isLoadingPage = false;
        });
    },
    getFormName(id) {
      if (this.formsComponent.length !== 0) {
        let res = this.formsComponent.form.filter((item) => item._id === id);
        if (typeof res[0] !== "undefined") {
          return res[0].name;
        } else {
          return this.$t("form.notFound");
        }
      }
    },
    openModalForm(item, type) {
      //console.log('item15151515',item)
      let obj = {
        _id: item.batchId,
        createdAt: item.createdAt,
        fiscalYear: item.fiscalYear,
        form: item.form,
        name: item.name,
      };
      this.batchData = obj;
      this.isFormModalType = type;
      this.renderComponent = true;
      this.radioForm = null;
      this.isForm = true;
      this.$store.commit("setModalActive", true);
      this.fetchStaff(item.batchId);
      if (type === "edit") {
        this.radioForm = { id: item.form[0].id, type: item.form[0].type };
      }

      this.formsUserData = item;
    },
    filter() {
      if (this.searchName == "" && this.searchBudget == "") {
        this.batchFormsFilter = this.batchForms;
      } else if (this.searchName != "" && this.searchBudget == "") {
        this.batchFormsFilter = this.batchForms.filter(
          (item) =>
            item.name.toLowerCase().indexOf(this.searchName.toLowerCase()) >= 0
        );
      } else if (this.searchName != "" && this.searchBudget != "") {
        this.batchFormsFilter = this.batchForms.filter(
          (item) =>
            item.name.toLowerCase().indexOf(this.searchName.toLowerCase()) >=
              0 &&
            item.fiscalYear
              .toLowerCase()
              .indexOf(this.searchBudget.toLowerCase()) >= 0
        );
      } else if (this.searchName == "" && this.searchBudget != "") {
        this.batchFormsFilter = this.batchForms.filter(
          (item) =>
            item.fiscalYear
              .toLowerCase()
              .indexOf(this.searchBudget.toLowerCase()) >= 0
        );
      } else {
        this.batchFormsFilter = this.batchForms;
      }

      if (typeof this.$refs.dropdowntablet !== "undefined") {
        this.$refs.dropdowntablet.isActive = false;
      }
    },
    resetFilter() {
      this.searchName = "";
      this.searchBudget = "";
      this.batchFormsFilter = this.batchForms;
    },
    closeModalIsForm() {
      this.$store.commit("setModalActive", false);
    },
    setRadioForm() {
      this.renderComponent = false;
      setTimeout(() => {
        this.renderComponent = true;
      }, 500);
    },
    changPage(batch, page) {
      if (batch === null) {
        this.batchData = null;
      } else {
        let obj = {
          _id: batch.batchId,
          createdAt: batch.createdAt,
          fiscalYear: batch.fiscalYear,
          form: batch.form,
          name: batch.name,
          under: batch.underName,
          underLogo: batch.underLogo,
        };
        this.batchData = obj;
      }
      this.page = page;
    },
  },
};
</script>
<style scoped>
.card {
  color: #0a0a0a;
}
.border-bottom {
  border-bottom: 1px solid #d8d8d8;
}
.scroll {
  overflow-y: scroll;
  height: 550px;
}
.scroll::-webkit-scrollbar {
  display: unset !important;
  -webkit-appearance: none;
  width: 7px;
}
.scroll::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: 0 0 1px rgba(216, 216, 216, 100%);
  background-color: rgba(216, 216, 216, 100%);
}
.scroll::-webkit-scrollbar-track {
  display: none;
}
.btn-form {
  min-height: 45px;
  background-color: #6d8df3;
  color: #ffffff;
}
.btn-form-outlined {
  min-width: 50%;
  min-height: 45px;
  border: 1px solid #6d8df3;
  color: #6d8df3;
}
.btn-form-add {
  min-width: 130px;
  min-height: 40px;
  border: 1px solid #6d8df3;
  color: #6d8df3;
  margin: 5px;
}
.edit-form {
  color: #707070;
}
.edit-form:hover {
  color: #6d8df3;
}
#noData {
  padding: 150px;
}
footer {
  opacity: 1 !important;
}
.pd-0-75rem {
  padding: 0 0.75rem;
}
</style>
